<!-- Connectors first: under the nodes, fanning from each open node to its children. -->
<svg:g xmlns:svg="http://www.w3.org/2000/svg" class="connectors">
    <svg:path *ngFor="let c of connectors" [attr.d]="c.d"
              fill="none" stroke="currentColor" stroke-opacity="0.28" stroke-width="1"></svg:path>
</svg:g>

<svg:g xmlns:svg="http://www.w3.org/2000/svg" class="nodes">
    <svg:g *ngFor="let col of columns">
        <svg:g *ngFor="let n of col"
               [attr.transform]="'translate(' + n.x + ',' + n.y + ')'"
               [style.cursor]="n.hasChildren && n.depth > 0 ? 'pointer' : 'default'"
               (click)="onNodeClick(n)"
               container="body" ngbPopover="{{n.text}}" triggers="mouseenter:mouseleave">
            <!-- Sibling-relative bar: muted full track + accent fill; open node reads stronger. -->
            <svg:rect x="0" y="0" [attr.width]="n.width" height="6" rx="1.5"
                      fill="currentColor" fill-opacity="0.12"></svg:rect>
            <svg:rect x="0" y="0" [attr.width]="n.barWidth" height="6" rx="1.5"
                      [attr.fill]="config.colors[0]"
                      [attr.fill-opacity]="n.expanded ? 1 : 0.55"></svg:rect>
            <svg:text x="0" y="19" font-size="11"
                      [attr.font-weight]="n.expanded ? 600 : 400"
                      fill="currentColor" [attr.fill-opacity]="n.expanded ? 0.95 : 0.75">{{n.label}}</svg:text>
            <svg:text x="0" y="31" font-size="10"
                      fill="currentColor" fill-opacity="0.55">{{n.valueText}}</svg:text>
            <!-- Affordance: collapsed nodes that can be opened get a small chevron. -->
            <svg:text *ngIf="n.hasChildren && !n.expanded && n.depth > 0"
                      [attr.x]="n.width + 4" y="8" font-size="9"
                      fill="currentColor" fill-opacity="0.45">›</svg:text>
        </svg:g>
    </svg:g>
</svg:g>
